import React from 'react';
import PropTypes from 'prop-types';

const CalendarPlusIcon = ({ color = 'black', size = 'large' }) => {
    if (size === 'large') {
        return (
            <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.5 8.5V12.5"
                    stroke={color}
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 10.5H10.5"
                    stroke={color}
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5 2.5H2.5C1.948 2.5 1.5 2.948 1.5 3.5V14.5C1.5 15.052 1.948 15.5 2.5 15.5H14.5C15.052 15.5 15.5 15.052 15.5 14.5V3.5C15.5 2.948 15.052 2.5 14.5 2.5Z"
                    stroke={color}
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M1.5 5.5H15.5"
                    stroke={color}
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.5 0.5V2.5"
                    stroke={color}
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 0.5V2.5"
                    stroke={color}
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        );
    }

    return (
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0)">
                <path
                    d="M6.875 6.875V9.875"
                    stroke={color}
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.375 8.375H8.375"
                    stroke={color}
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.375 2.375H2.375C1.961 2.375 1.625 2.711 1.625 3.125V11.375C1.625 11.789 1.961 12.125 2.375 12.125H11.375C11.789 12.125 12.125 11.789 12.125 11.375V3.125C12.125 2.711 11.789 2.375 11.375 2.375Z"
                    stroke={color}
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M1.625 4.625H12.125"
                    stroke={color}
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.625 0.875V2.375"
                    stroke={color}
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.125 0.875V2.375"
                    stroke={color}
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect width="12" height="12" fill={color} transform="translate(0.5 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

CalendarPlusIcon.propTypes = {
    color: PropTypes.string,
    size: PropTypes.string,
};

export default CalendarPlusIcon;
